Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-user-wishlist-widget');
    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);
    var model;
    var openWidget = false;

    wrapper.loading = function (loading) {
        if (loading) {
            $(".js-widget-container", $wrapper).addClass('x-loading');
        } else {
            $(".js-widget-container", $wrapper).removeClass('x-loading');
        }
    };

	wrapper.open = function () {
		$(".js-widget-trigger", $wrapper).addClass('x-open');
		$(".js-widget-container", $wrapper).addClass('x-expanded');

		openWidget = false;
		Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.WishlistWidget));
	};

	wrapper.close = function () {
		$(".js-widget-trigger", $wrapper).removeClass('x-open');
		$(".js-widget-container", $wrapper).removeClass('x-expanded');
	};

	if (isTouch()) {
        $wrapper.on('click', '.js-widget-trigger', function (e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('x-open')) {
                wrapper.close();
            } else {
                wrapper.open();
            }
        });
    }
    else {
        var config = {
            sensitivity: 2,
            interval: 50,
            timeout: 200,
            over: function () {
                wrapper.open();
            },
            out: function () {
                wrapper.close();
            }
        };

        $wrapper.hoverIntent(config);
	}

    wrapper.update = function () {

        wrapper.loading(true);
		model.NewListPlaceHolder = model.DefaultListName;
        var html = Vendd.Handlebars.parse("userWishlistsWidget", model);
        $wrapper.html(html);

		if (openWidget) {
			wrapper.open();
		}

        wrapper.loading(false);
    };


    $wrapper.on('click', '.js-list-delete', function (e) {
        e.preventDefault();

        var $this = $(this);
		var $item = $this.closest('.product-wishlist');
        var listId = $item.data('list-id');
		var qs = LhApp.Function.QueryString.getValueOf('list');
		if (!listId && qs) listId = parseInt(qs);

		if (!listId) return false;
        var data = { visitorListId: listId };

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserWishlist.Messages.DeleteWishlist(data));
    });

	$wrapper.on('keyup', '.list-name', function (e) {
		if (e.keyCode === 13) {
			$('.js-list-create', $wrapper).trigger('click');
		}
	});

    $wrapper.on('click', '.js-list-create', function (e) {
        e.preventDefault();

        var $item = $('.list-name', $wrapper);
		var listName = $item.val() ? $item.val() : model.DefaultListName;

        var data = {
            Name : listName, 
            VisitorListId: 0
        };
        
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserWishlist.Messages.SaveWishlist(data));
    });
    

    Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.SaveWishlistFailed, wrapper, function (envelope) {
        var errorEl = $('span.js-error-message', wrapper);
        
        if (envelope.message.data && envelope.message.data.message && errorEl.length > 0)
            errorEl.text(envelope.message.data.message);
    });

    Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.GetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data;
		wrapper.update();
		//if (envelope.message.data.immediate === true)
		//	wrapper.open();
		//else
		//	openWidget = true; // the next refresh will open it
    });
    

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserWishlist.Messages.GetModel());
});

